/** The stages shown while a monitoring brief is being submitted. */
export const MONITORING_SUBMIT_STAGES: string[] = [
  'Creating your monitoring brief',
  'Attaching the creators to monitor',
  'Handing the brief to the monitoring engine',
];

/** Phrases shown while SHOUT AI streams a monitoring draft. */
export const MONITORING_AI_DRAFT_PHRASES: string[] = [
  'Reading what you want to watch',
  'Drafting the brief overview',
  'Writing the requirements',
  'Noting what should be flagged',
  'Pulling it all together',
];
